import { Close, Save } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, InputAdornment, MenuItem, Select } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonButton from 'components/ArgonButton'
import ArgonInput from 'components/ArgonInput'
import ArgonTypography from 'components/ArgonTypography'
import { postSubmit } from 'global/postFunc'
import React, { useEffect, useState } from 'react'

const listBulan = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember'
];

const InputLaporan = ({ decryptedUser, addReq, open, handleClose, dataKomponen, dataRealisasi, bulan, updating, setUpdating }) => {
    const [saving, setSaving] = useState(false)

    const [realisasiKeuangan, setRealisasiKeuangan] = useState('')
    const [statusPelaksanaan, setStatusPelaksanaan] = useState('')
    const [realisasiFisik, setRealisasiFisik] = useState('')
    const [permasalahan, setPermasalahan] = useState('')

    useEffect(() => {
        if (open) {
            console.log(dataRealisasi);
            console.log(dataKomponen);
            console.log(bulan);
            setRealisasiKeuangan(dataRealisasi.realisasi_keuangan || '')
            setStatusPelaksanaan(dataRealisasi.status_pelaksanaan || '')
            if (dataKomponen.metode_pengadaan === 'Swakelola' && parseInt(dataKomponen.volume) > 1) {
                setRealisasiFisik(dataRealisasi.realisasi_fisik || '')
            }
            else {
                setRealisasiFisik(dataRealisasi.realisasi_fisik_persen || '')
            }

            setPermasalahan(dataRealisasi.setPermasalahan || '')
        }
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    const submit = (e) => {
        e.preventDefault()
        let rU = realisasiKeuangan.replace(/,/g, '');
        let formData = {
            id: dataRealisasi?.id || null,
            ta: dataKomponen.ta,
            kd_pd: dataKomponen.kd_pd,
            kd_subkegiatan: dataKomponen.kd_subkegiatan,
            kode_rekening_akun: dataKomponen.kode_rekening_akun,
            uraian_rekening_akun: dataKomponen.uraian_rekening_akun,
            id_komponen: dataKomponen.id,
            nama_komponen: dataKomponen.nama_komponen,
            bulan: bulan,
            realisasi_keuangan: rU,
            realisasi_keuangan_persen: ((parseInt(rU) / parseInt(dataKomponen.anggaran)) * 100).toFixed(2),
            realisasi_fisik: (dataKomponen.metode_pengadaan === 'Swakelola' && parseInt(dataKomponen.volume) > 1) ? realisasiFisik : (parseFloat(realisasiFisik) / 100).toFixed(2),
            realisasi_fisik_persen: (dataKomponen.metode_pengadaan === 'Swakelola' && parseInt(dataKomponen.volume) > 1) ? ((parseInt(realisasiFisik) / parseInt(dataKomponen.volume)) * 100).toFixed(2) : realisasiFisik,
            status_pelaksanaan: statusPelaksanaan,
            permasalahan: permasalahan
        }
        addReq()
        setSaving(true)
        postSubmit(
            '/admin-opd/realisasi/tambah',
            formData,
            decryptedUser,
            (res) => {
                setSaving(false)
                handleClose()
                setUpdating(!updating)
            },
            (res) => {
                setSaving(false)
                handleClose()
            }
        )
    }

    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
    const handleAnggaranChange = (event) => {
        setRealisasiKeuangan(addCommas(removeNonNumeric(event.target.value)))
    }

    return (
        <Dialog
            onClose={handleClose}
            open={open}
            maxWidth="md"
            fullWidth
            scroll='paper'
            p={3}
            component='form'
            onSubmit={submit}
            sx={{
                minHeight: '80vh'
            }}
        >
            <DialogTitle>
                <ArgonTypography variant='body2' fontWeight="bold">
                    Input Progres Bulan {listBulan[bulan - 1]}
                </ArgonTypography>
            </DialogTitle>
            <DialogContent p={3}>
                <ArgonBox mb={1}>
                    <ArgonBox ml={0.5} mb={1}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Realisasi Keuangan
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonInput
                        required
                        size="medium"
                        type="text"
                        value={realisasiKeuangan}
                        onChange={handleAnggaranChange}
                        autoComplete='off'
                        startAdornment={<InputAdornment position="start">
                            <ArgonTypography fontSize='small'>Rp</ArgonTypography>
                        </InputAdornment>}
                    />
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox ml={0.5} mb={1}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Realisasi Fisik
                        </ArgonTypography>
                    </ArgonBox>
                    {
                        (dataKomponen.metode_pengadaan === 'Swakelola' && parseInt(dataKomponen.volume)) > 1 ?
                            (
                                <Grid container spacing={2} justifyContent='center'>
                                    <Grid item lg={6} xs={12}>
                                        <ArgonBox ml={0.5} mb={1}>
                                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                Status Pelaksanaan
                                            </ArgonTypography>
                                        </ArgonBox>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={statusPelaksanaan || ''}
                                            onChange={(e) => {
                                                setStatusPelaksanaan(e.target.value)
                                            }}
                                            required
                                        >
                                            <MenuItem key={1} value='Persiapan'>Persiapan</MenuItem>
                                            <MenuItem key={2} value='Pelaksanaan'>Pelaksanaan</MenuItem>
                                            <MenuItem key={3} value='Selesai'>Selesai</MenuItem>
                                        </Select>
                                    </Grid>
                                    <Grid item lg={6} xs={12}>
                                        <ArgonBox ml={0.5} mb={1}>
                                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                Volume Realisasi
                                            </ArgonTypography>
                                        </ArgonBox>
                                        <ArgonInput
                                            required
                                            size="medium"
                                            type="number"
                                            onKeyDown={(e) => {
                                                if (e.key === "e" || e.key === "." || e.key === "+" || e.key === "-" || e.key === ",") {
                                                    return e.preventDefault()
                                                }
                                            }}
                                            value={realisasiFisik}
                                            onChange={(e) => { setRealisasiFisik(e.target.value) }}
                                            autoComplete='off'
                                            endAdornment={
                                                <InputAdornment position="end" >
                                                    <ArgonTypography fontSize='small'>{dataKomponen.satuan}</ArgonTypography>
                                                </InputAdornment>
                                            }
                                        />
                                    </Grid>
                                </Grid >
                            )
                            :
                            (
                                <Grid container spacing={2} justifyContent='center'>
                                    <Grid item lg={6} xs={12}>
                                        <ArgonBox ml={0.5} mb={1}>
                                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                Status Pelaksanaan
                                            </ArgonTypography>
                                        </ArgonBox>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={statusPelaksanaan || ''}
                                            onChange={(e) => {
                                                setStatusPelaksanaan(e.target.value)
                                            }}
                                            required
                                        >
                                            <MenuItem key={4} value='Persiapan'>Persiapan</MenuItem>
                                            <MenuItem key={5} value='Pelaksanaan'>Pelaksanaan</MenuItem>
                                            <MenuItem key={6} value='Selesai'>Selesai</MenuItem>
                                        </Select>
                                    </Grid>
                                    <Grid item lg={6} xs={12}>
                                        <ArgonBox ml={0.5} mb={1}>
                                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                                Bobot Realisasi
                                            </ArgonTypography>
                                        </ArgonBox>
                                        <ArgonInput
                                            required
                                            type="number"
                                            size="medium"
                                            value={realisasiFisik}
                                            onChange={(e) => { setRealisasiFisik(e.target.value) }}
                                            autoComplete='off'
                                            onKeyDown={(e) => {
                                                if (e.key === "e" || e.key === "+" || e.key === "-" || e.key === ",") {
                                                    return e.preventDefault()
                                                }
                                            }}
                                            endAdornment={
                                                <InputAdornment position="end" >
                                                    <ArgonTypography fontSize='small'>%</ArgonTypography>
                                                </InputAdornment>
                                            }
                                        />
                                    </Grid>
                                </Grid >
                            )
                    }

                </ArgonBox >
                <ArgonBox mb={1}>
                    <ArgonBox ml={0.5} mb={1}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Permasalahan
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonInput
                        size="medium"
                        value={permasalahan}
                        onChange={(e) => { setPermasalahan(e.target.value) }}
                        autoComplete='off'
                        multiline
                        rows={3}
                    />
                </ArgonBox>
            </DialogContent >
            <DialogActions>
                <Grid container spacing={2} justifyContent='flex-end' px={2} mb={2}>
                    <Grid item>
                        <ArgonButton color='info' variant='outlined' size="small" startIcon={<Close />} onClick={handleClose}>Batal</ArgonButton>
                    </Grid>
                    <Grid item>
                        <LoadingButton color='info' variant='contained' size="small" startIcon={<Save />} type='submit' loading={saving}>Simpan</LoadingButton>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog >
    )
}

export default InputLaporan